import React from "react";
import { Bell, LogOut } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { logout } from "../../utils/auth";
import { showConfirmDialog } from "../../components/ConfirmDialog";
import {
  MobilePageShell,
  MobilePageHeader,
  MobileNavGroup,
  MobileNavRow,
} from "./MobileNavPrimitives";

export default function SettingsScreen() {
  const navigate = useNavigate();

  const handleLogout = async () => {
    const confirm = await showConfirmDialog({
      title: "Xác nhận đăng xuất",
      text: "Bạn có chắc chắn muốn rời khỏi hệ thống không?",
      confirmText: "Đăng xuất",
      cancelText: "Ở lại",
    });
    if (confirm.isConfirmed) {
      logout();
      window.location.href = "/login";
    }
  };

  return (
    <MobilePageShell>
      <MobilePageHeader
        title="Cài đặt"
        subtitle="Tùy chọn ứng dụng"
        tone="slate"
      />

      <div className="space-y-5 px-5 pt-5 pb-4">
        <MobileNavGroup>
          <MobileNavRow
            icon={Bell}
            label="Thông báo"
            hint="Hộp thư & gửi email"
            tone="emerald"
            onClick={() => navigate("/m/settings/notifications")}
          />
        </MobileNavGroup>

        <MobileNavGroup>
          <MobileNavRow
            icon={LogOut}
            label="Đăng xuất"
            danger
            onClick={handleLogout}
          />
        </MobileNavGroup>
      </div>
    </MobilePageShell>
  );
}
